import type {
  ActiveSeasonView,
  SeasonCampaignDetail,
  SeasonCampaignDivisionDetail,
} from '@multirx/shared/types/championship.js';

/** Adapte une division de campagne archivée au shell de carte championnat. */
export function campaignDivisionToActiveView(
  detail: SeasonCampaignDetail,
  division: SeasonCampaignDivisionDetail
): ActiveSeasonView {
  const currentMeeting =
    division.meetings.find((m) => m.status === 'in_progress') ??
    division.meetings.find((m) => m.status === 'completed') ??
    division.meetings[0] ??
    null;
  return {
    season: {
      id: division.seasonId,
      division: division.division,
      status: detail.status,
      meetingCount: detail.meetingCount,
      currentMeetingIndex: detail.currentMeetingIndex,
      createdAt: detail.startedAt,
    },
    currentMeeting,
    nextSession: null,
    standings: division.standings,
  };
}
